import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { SearchPipe, OrderPipe, AMPM } from "./common-pipe.pipe";
import { PercentageSign } from "./directives";
import { MultiModule } from "./multi/multi.module";
import {
  CMaxlength,
  CustomPattern,
  MainError,
  OnlyNumber,
  CheckMin,
  NumberOrDecimal,
  Searched,
  SelectSearchComponent,
} from "./directives";
import { KeyboardDisabled } from "./directives";
import { DotDisabled, CheckMaxValue, SlabRangeDirective } from "./directives";
import { PaginationModule } from "./pagination/pagination.module";
import { MyDateRangePickerModule } from "mydaterangepicker";
import { MyDatePickerModule } from "mydatepicker";
import { RlTagInputModule } from "./angular2-tag-input";
import { NumberValidations } from "./directives/custom.directive";
import { NgInitDirective } from "./directives/ng-init.directive";
import { UserRolesDirective } from "./directives/user-roles.directive";
import { FocusDirective } from "./directives/focus-directive";
import { CookieModule } from "./cookies";
import { LoadingSpinnerComponent } from "./loading-spinner/loading-spinner.component";

@NgModule({
  imports: [
    CommonModule,
    PaginationModule,
    MultiModule,
    RlTagInputModule,
    FormsModule,
  ],
  declarations: [
    SearchPipe,
    PercentageSign,
    CMaxlength,
    KeyboardDisabled,
    DotDisabled,
    CheckMaxValue,
    OrderPipe,
    CustomPattern,
    MainError,
    SlabRangeDirective,
    OnlyNumber,
    CheckMin,
    NumberOrDecimal,
    NumberValidations,
    NgInitDirective,
    Searched,
    SelectSearchComponent,
    FocusDirective,
    UserRolesDirective,
    AMPM,
    LoadingSpinnerComponent,
  ],
  providers: [],
  exports: [
    CommonModule,
    FormsModule,
    NgbModule,
    SearchPipe,
    PercentageSign,
    CMaxlength,
    CustomPattern,
    PaginationModule,
    MultiModule,
    KeyboardDisabled,
    DotDisabled,
    CheckMaxValue,
    OrderPipe,
    MyDatePickerModule,
    MyDateRangePickerModule,
    MainError,
    SlabRangeDirective,
    OnlyNumber,
    CheckMin,
    NumberOrDecimal,
    NumberValidations,
    NgInitDirective,
    Searched,
    RlTagInputModule,
    SelectSearchComponent,
    UserRolesDirective,
    FocusDirective,
    CookieModule,
    AMPM,
    LoadingSpinnerComponent,
  ],
})
export class SharedModule {}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/ARES-admin-frontend/src/app/common/shared.module.ts